import React from 'react';
import '../styles/services.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

const Services = () => {
	return (

		<section id="what-we-do">
			<div className="service justify-content-center ">
				<h2 className="section-title mb-2 h1">What we do</h2>
				<div className="row">
					<div className="col-lg-6" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="800">
						<div className="card">
							<div className="card-block block-1">
								<h3 className="card-title">Project/Event Management</h3>
								<p className="card-text">Events, Concepts for projects, event planning, exhibitions</p>
							</div>
						</div>
					</div>
					<div className="col-lg-6" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="800">
						<div className="card">
							<div className="card-block block-2">
								<h3 className="card-title">Marketing and Communication</h3>
								<p className="card-text">PR, Publicity, Communication Strategies, Sponsorships</p>
							</div>
						</div>
					</div>
					<div className="col-lg-6" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="800">
						<div className="card">
							<div className="card-block block-3">
								<h3 className="card-title">Brand Activations</h3>
								<p className="card-text">Campaigns, Managing of all elements of activations</p>
							</div>
						</div>
					</div>
					<div className="col-lg-6" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="800">
						<div className="card card-center">
							<div className="card-block block-4">
								<h3 className="card-title">Multi Media & Video Production</h3>
								<p className="card-text">Radio Production, Film and Video Production</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Services